exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Therapy{margin:0 auto;width:288px}.Therapy-header{font-size:24px;font-weight:500;margin-bottom:40px}.Therapy-subHeader{font-size:14px;font-weight:400;margin-top:4px;letter-spacing:-0.2px}", ""]);

// exports
